import { useEffect, useState } from "react";

import { getCurrencies } from "../currency/currency";

import type { AeronetV6Response, Currency } from "../types";

let cachedCurrencies: AeronetV6Response<Currency> | undefined;
let currenciesLoadPromise: Promise<AeronetV6Response<Currency>> | undefined;

function loadCurrenciesData(): Promise<AeronetV6Response<Currency>> {
  if (cachedCurrencies) {
    return Promise.resolve(cachedCurrencies);
  }
  if (!currenciesLoadPromise) {
    currenciesLoadPromise = getCurrencies()
      .then((resp) => {
        cachedCurrencies = resp.data;
        return cachedCurrencies;
      })
      .catch((err) => {
        currenciesLoadPromise = undefined;
        throw err;
      });
  }
  return currenciesLoadPromise;
}

/** Call after create/update/delete so the next hook consumer refetches. */
export function invalidateCurrenciesCache(): void {
  cachedCurrencies = undefined;
  currenciesLoadPromise = undefined;
}

/** Loads /v6/currency once per session (shared across all consumers). */
export function useCurrencies(): AeronetV6Response<Currency> | undefined {
  const [currency, setCurrency] = useState<AeronetV6Response<Currency>>();

  useEffect(() => {
    let active = true;
    loadCurrenciesData()
      .then((data) => {
        if (active) {
          setCurrency(data);
        }
      })
      .catch(() => {
        if (active) {
          setCurrency(undefined);
        }
      });
    return () => {
      active = false;
    };
  }, []);

  return currency;
}
